<template>
	<div :class="`screen screen--color-${color} screen--align-${align} screen--title-${hasTitle}`">
		<div v-if="isMobile">
			<div class="screen__bg"></div>
			<div class="container">
				<div class="screen__box">
					<div :class="`screen__heading ${titleClass}`" v-if="titleClass">
						<div class="screen__heading-title"><slot name="heading-title"></slot></div>
						<div class="screen__heading-subtitle"><slot name="heading-subtitle"></slot></div>
					</div>
					<div class="screen__heading" v-else>
						<div class="screen__heading-title"><slot name="heading-title"></slot></div>
						<div class="screen__heading-subtitle"><slot name="heading-subtitle"></slot></div>
					</div>
					<div class="screen__container">
						<div class="screen__content">
							<div class="screen__title"><slot name="title"></slot></div>
							<div class="screen__text"><slot name="text"></slot></div>
							<div v-if="button">
								<div class="screen__link"><a :href="link" target="_blank" @click="sendEvent(event2, event2_m)">Смотреть</a></div>
							</div>
						</div>
						<div class="screen__image" :class="{'screen__video': videoPlay}" v-if="vimeo" @click="playVideoEvent">
							<div v-if="!videoPlay">
								<slot name="image"></slot>
							</div>
							<vimeo-player :video-id='vimeo' v-if="videoPlay" :autoplay="true"></vimeo-player></div>
						<a :href="link" class="screen__image screen__image--noplay" target="_blank" @click="sendEvent(event1, event1_m)" v-else><slot name="image"></slot></a>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<transition :name="`bg-${align}`" appear>
				<div class="screen__bg" v-if="number == active"></div>
			</transition>
			<div class="container">
				<div :class="`screen__arrow screen__arrow--${color}`" v-if="hasTitle"></div>
				<div class="screen__box">
						<div class="screen__top">
							<div :class="`screen__heading ${titleClass}`" v-if="titleClass">
								<transition :name="`fade-down`" appear>
											<div class="screen__heading-title" v-if="number == active" style="transition-delay: 300ms"><slot name="heading-title"></slot></div>
								</transition>
								<transition :name="`fade-down`" appear>
											<div class="screen__heading-subtitle" v-if="number == active" style="transition-delay: 300ms"><slot name="heading-subtitle"></slot></div>
								</transition>
							</div>
							<div class="screen__heading" v-else>
								<div class="screen__heading-title"><slot name="heading-title"></slot></div>
								<div class="screen__heading-subtitle"><slot name="heading-subtitle"></slot></div>
							</div>
						</div>
					<div class="screen__container">
						<div class="screen__content">
							<transition :name="`fade-${align}`" appear>
							<div class="screen__title" v-if="number == active"><slot name="title" style="transition-delay: 300ms"></slot></div>
							</transition>
							<transition :name="`fade-${align}`" appear>
							<div class="screen__text" v-if="number == active"><slot name="text" style="transition-delay: 300ms"></slot></div>
							</transition>
							<div v-if="button">
								<transition :name="`fade-${align}`" appear>
								<div class="screen__link" v-if="number == active"><a :href="link" target="_blank"  @click="sendEvent(event2, event2_m)" style="transition-delay: 300ms">Смотреть</a></div>
								</transition>
							</div>
						</div>

						<transition :name="`fade-${alignInvert}`" appear>
							<div v-if="number == active" style="transition-delay: 400ms">
								<div class="screen__image" :class="{'screen__video': videoPlay}" v-if="vimeo" @click="playVideoEvent">
									<div v-if="!videoPlay">
										<slot name="image"></slot>
									</div>
									<vimeo-player :video-id='vimeo' v-if="videoPlay" :autoplay="true"></vimeo-player>
								</div>
								<a :href="link" class="screen__image screen__image--noplay" @click="sendEvent(event1, event1_m)" target="_blank" v-if="!vimeo"><slot name="image"></slot></a>
							</div>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import vueVimeoPlayer from 'vue-vimeo-player'
	import Vue from 'vue'

	Vue.use(vueVimeoPlayer)

	export default {
		name: 'Screen',
		data() {
			return {
				videoPlay: false,
			}
		},
		props: {
			color: String,
			align: String,
			link: String,
			hasTitle: Boolean,
			button: Boolean,
			titleClass: String,
			number: Number,
			active: Number,
			vimeo: String,
			event1: String,
			event1_m: String,
			event2: String,
			event2_m: String,
		},
		methods: {
			playVideoEvent() {
				this.videoPlay = true;
				this.sendEvent(this.event1, this.event1_m);
			},
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		},
		computed: {
			isMobile() {
				if (window.innerWidth < 960) {
					return true;
				}
				return false;
			},
			alignInvert() {
				if (this.align == 'left') {
					return 'right'
				} else {
					return 'left'
				}
			},
		}
	}
</script>

<style>
.fade-left-enter-active, .fade-left-leave-active {
  transition: all 1.5s;
}
.fade-left-enter, .fade-left-leave-to {
  opacity: 0;
  transform: translateX(-90px);
}
.fade-down-enter-active, .fade-down-leave-active {
  transition: all 1.5s;
}
.fade-down-enter, .fade-down-leave-to {
  opacity: 0;
  transform: translateY(-190px);
}

.fade-right-enter-active, .fade-right-leave-active {
  transition: all 1.5s;
}
.fade-right-enter, .fade-right-leave-to {
  opacity: 0;
  transform: translateX(90px);
}
.bg-left-enter-active, .bg-left-leave-active {
  transition: all 1.5s;
}
.bg-left-enter, .bg-left-leave-to {
  opacity: 0;
  transform: translateX(90px);
}
.bg-right-enter-active, .bg-right-leave-active {
  transition: all 1.5s;
}
.bg-right-enter, .bg-right-leave-to {
  opacity: 0;
  transform: translateX(-90px);
}
</style>

<style lang="sass">
	.page
		.button
			@media screen and (max-width: 1000px)
				left: vwm(-20px) !important
				top: vwm(806px)
	.page-2
		.button
			@media screen and (max-width: 1000px)
				top: vwm(764px)
	.page-3
		.button
			@media screen and (max-width: 1000px)
				top: vwm(771px)
	.page-4
		.button
			@media screen and (max-width: 1000px)
				top: vwm(780px)
	.screen
		height: 100vh
		position: relative
		width: 100%
		@media screen and (max-width: 1000px)
			height: auto
			padding-bottom: vwm(56px) !important
			min-height: vwm(1px)
		&__arrow
			width: vw(16px)
			height: vw(52px)
			position: absolute
			bottom: vw(41px)
			left: 0
			right: 0
			margin: auto
			background-image: url(../../assets/img/arrow-2.svg)
			background-size: contain
			background-position: 50% 50%
			background-repeat: no-repeat
			animation: down
			animation-timing-function: linear
			animation-duration: 5s
			animation-iteration-count: infinite
			left: vw(73px)
			&--red
				background-image: url(../../assets/img/arrow-2-red.svg)
			&--blue
				background-image: url(../../assets/img/arrow-2-blue.svg)
			&--purpure
				background-image: url(../../assets/img/arrow-2-purpure.svg)
			@media screen and (max-width: 1000px)
				display: none
		&__box
			height: 100vh
			display: flex
			flex-direction: column
			justify-content: center
			padding-left: vw(74.8px)
			padding-right: vw(74.8px)
			padding-bottom: vw(19px)
			@media screen and (max-width: 1000px)
				height: auto
				min-height: vwm(1px)
				padding-left: 0
				padding-right: 0
				flex-direction: column
		&__heading
			z-index: 10
			position: absolute
			top: vw(72px)
			left: vw(-126px)
			width: 100%
			@media screen and (max-width: 1000px)
				position: relative
				left: 0
				top: 0
			&-title
				font-size: vw(50px)
				text-align: center
				color: $white
				font-family: 'Oswald'
				text-transform: uppercase
				text-shadow: 10px 10px 20px rgba(8, 58, 102, 0.2)
				@media screen and (max-width: 1000px)
					padding-top: 0
					font-size: vwm(39px)
					text-align: center
					margin-top: vwm(108px)
					width: 100%
					letter-spacing: vwm(0.2px)
					line-height: 1.3
					color: $blue
				span
					color: $blue
					padding-left: vw(5px)
			&-subtitle
				font-size: vw(24px)
				text-align: center
				font-weight: 300
				color: $white
				font-family: 'Montserrat'
				text-transform: uppercase
				text-shadow: 10px 10px 20px rgba(8, 58, 102, 0.2)
				margin-top: vw(20px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(20px)
					font-size: vwm(24px)
					color: $blue
				span
					color: $blue
					padding-left: vw(5px)
			&--1
				left: vw(26px)
			&--2
				left: vw(12px)
				.screen__heading-subtitle
					padding-right: vw(52px)
			&--3
				left: vw(23px)
				.screen__heading-subtitle
					padding-right: vw(71px)
		&__container
			display: flex
			align-items: center
			justify-content: space-between
			position: relative
			z-index: 10
			@media screen and (max-width: 1000px)
				flex-direction: column-reverse
				margin-top: vwm(23px)
		&__content
			width: vw(528px)
			font-family: 'Montserrat'
			font-size: vw(14px)
			line-height: vw(20px)
			color: rgba(0, 46, 86, 0.7)
			@media screen and (max-width: 1000px)
				width: 100%
				font-size: vwm(14px)
				line-height: vwm(20px)
				br
					display: none
		&__title
			font-size: vw(24px)
			line-height: vw(36px)
			font-weight: 600
			text-transform: uppercase
			color: $blue
			font-family: 'Oswald'
			margin-bottom: vw(10px)
			@media screen and (max-width: 1000px)
				padding-top: vwm(19px)
				font-size: vwm(24px)
				line-height: vwm(37px)
				margin-left: vwm(-2px)
				margin-bottom: vwm(7px)
				br
					display: none
		&__link
			a
				display: inline-block
				min-width: vw(138px)
				padding-left: vw(10px)
				padding-right: vw(10px)
				height: vw(40px)
				line-height: vw(40px)
				font-size: vw(14px)
				color: #fff
				text-align: center
				border-radius: vw(50px)
				text-decoration: none
				font-family: 'Montserrat'
				margin-top: vw(25px)
				font-weight: 600
				background-color: $purpure
				box-shadow: 10px 10px 20px rgba(50, 93, 130, 0.13)
				transition: all 300ms
				@media screen and (max-width: 1000px)
					min-width: vwm(138px)
					padding-left: vwm(10px)
					padding-right: vwm(10px)
					height: vwm(40px)
					line-height: vwm(40px)
					font-size: vwm(14px)
					border-radius: vwm(50px)
					margin-top: vwm(15px)
				&:hover
					background-color: #841D70
					transform: scale(1.1)
		&__image
			width: vw(661px)
			height: vw(372px)
			cursor: pointer
			position: relative
			display: block
			box-shadow: 20px 20px 20px 0px rgba(34, 81, 121, 0.2)
			@media screen and (max-width: 1000px)
				width: 100%
				height: vwm(188px)
			&:hover
				&:before
					opacity: 0 !important
				&:after
					background-image: url(../../assets/img/play-2.svg)
					background-color: #fff !important
					background-position: 56% 50% !important
					background-size: vw(32px) !important
			&:before
				content: ''
				display: block
				width: 100%
				height: 100%
				position: absolute
				left: 0
				background-color: rgba(0,0,0,0.5)
				top: 0
				transition: all 300ms
			&:after
				content: ''
				display: block
				width: vw(98px)
				height: vw(98px)
				position: absolute
				left: 0
				top: 0
				cursor: pointer
				border-radius: 50%
				background-repeat: no-repeat
				background-position: 50% 50%
				background-size: contain
				bottom: 0
				right: 0
				margin: auto
				z-index: 100
				background-image: url(../../assets/img/play.svg)
				@media screen and (max-width: 1000px)
					width: vwm(49px)
					height: vwm(49px)
			&--noplay
				&:after
					display: none !important
			img
				width: 100%
		&__video
			&:before
				display: none !important
			&:after
				display: none !important
			iframe
				width: 100%
				height: 100%
			&>div
				width: 100%
				height: 100%
		&__bg
			width: 50%
			height: 100%
			content: ''
			display: block
			position: absolute
			right: 0
			top: 0
			background-color: $purpure
			background-image: url(../../assets/images/bg.png)
			@media screen and (max-width: 1000px)
				width: 100% !important
				height: vwm(354px)
		&--color-red
			.screen__bg
				background-color: $red
			.screen__link a 
				background-color: $red
				&:hover
					background-color: #E02125
			.screen__image
				&:hover
					&:after
						background-image: url(../../assets/img/play-3.svg)
			@media screen and (max-width: 1000px)
				.screen__heading-title
					color: #fff
					span
						color: #fff
				.screen__heading-subtitle
					color: #fff
					span
						color: #fff
		&--align-right
			.screen__container
				flex-direction: row-reverse
				@media screen and (max-width: 1000px)
					flex-direction: column-reverse
			.screen__bg
				left: 0
		&--color-blue
			.screen__bg
				background-color: $lightblue
			.screen__link a 
				background-color: $lightblue
				&:hover
					background-color: #0397C0
			.screen__image
				&:hover
					&:after
						background-image: url(../../assets/img/play-5.svg)
		&--color-yellow
			.screen__bg
				background-color: $yellow
			.screen__link a 
				background-color: $yellow
				&:hover
					background-color: #E6C468
			.screen__image
				&:hover
					&:after
						background-image: url(../../assets/img/play-4.svg)
		&--title-false
			@media screen and (max-width: 1000px)
				.screen__bg
					height: vwm(192px) !important
				.screen__container
					margin-top: vwm(98px)
				.screen__heading
					display: none !important
		&--title-true
			padding-top: vw(26px)
	@keyframes down
		0%
			transform: translateY(vw(0px))
		25%
			transform: translateY(vw(20px))
		50%
			transform: translateY(vw(0px))
		75%
			transform: translateY(vw(20px))
		100%
			transform: translateY(vw(0px))
</style>